import BaseClient from './BaseClient';

class BillingClient extends BaseClient {
    getBillingDetails(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing`);
    }

    updateInformation(teamId, data) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/information`, 'put', data);
    }

    updateBillingEmail(teamId, data) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/email`, 'put', data);
    }

    createSetupIntent(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/setup-intent`, 'post');
    }

    updatePaymentMethod(teamId, stripePaymentMethod) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/payment-method`, 'put', {
            stripe_payment_method: stripePaymentMethod,
        });
    }

    getProformaInvoice(teamId, periodDate) {
        const params = periodDate ? { period_date: periodDate } : null;
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/proforma-invoice`, 'get', null, params);
    }

    getInvoices(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/billing/invoices`);
    }
}

export default new BillingClient();
